module.exports = __webpack_public_path__ + "img/67.960ab8fc.png";